import { query,mutate,destroy, update } from "../../defaults/fetch";
import {useEffect,useState} from "react";



export const useCreatePVType = ()=>{
    const createPVType = async (body)=>{
        const url = `salary-structure/create`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return createPVType;
}



export const usePVTypes = (flag)=>{
    const [structures,setStructures ] = useState([]);
    const [loading,setLoading] = useState(false);

    const getPVTypes = async ()=>{
        setLoading(true);
        const url = `salary-structure/get-all`;
        const qs = {
            page:0,
            size:50
        };
        const {data} = await query(url,qs);
        setLoading(false);
        setStructures(data.content);
    }

    useEffect(()=>{
        getPVTypes()
    },[flag])

    return {loading, structures};
 }


 export const useUpdatePVType = ()=>{
    const updatePVType = async (id,body)=>{
        const url = `salary-structure/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }

    return updatePVType
 }



 export const useDeletePVType = ()=>{
    const deletePVType = async (id)=>{
        const url = `salary-structure/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deletePVType;
 }
